import SelectKind from './SelectKind';

export default SelectKind;
